import React from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { IProtectedRoute } from "../Interfaces/IProtectedRoute";
import { filterPayloadType } from "../Types/filterPayloadType";
import store from "../Store/store";
import { storeFilter } from "../Redux/Actions/filterActions";

export const ProtectedRoute: React.FC<IProtectedRoute> = ({
  path,
  component,
  nestedRoutedParent,
  routes,
}) => {
  const user = useSelector((state: any) => state.auth.user);
  // const history = useHistory()
  // let isReload = localStorage.getItem("isReload") || "";
  // if (isReload === "true") {
  //   let beforeReloadPathJson = localStorage.getItem("beforeRefreshObject") || "";
  //   let beforeReloadPath = beforeReloadPathJson !== "" ? JSON.parse(beforeReloadPathJson) : "";

  //   let beforeRelaodComponent: any;
  //   if (beforeReloadPath !== "" && beforeReloadPath !== undefined && beforeReloadPath.path!==undefined) {
  //     routes.filter(x => {
  //       if (x.path.toLocaleLowerCase() === beforeReloadPath.path.toLocaleLowerCase()) {
  //         beforeRelaodComponent = x.component
  //       }
  //     })
  //   }
  //   if (beforeReloadPath.path !== "" && beforeReloadPath.path !== undefined && beforeRelaodComponent !== "" && beforeRelaodComponent !== undefined) {
  //     consolelog('Relaod', beforeReloadPath)
  //     store.dispatch(storeFilter(beforeReloadPath.data))
  //     //history.push(path, { "HeaderName": beforeReloadPath.headerSuffix })
  //     return (
  //       user ? (<Route path={beforeReloadPath.path} component={beforeRelaodComponent} />)
  //         : (<Redirect to={'/login'} />)
  //     );
  //   }
  // }

  // consolelog('Relaod path', path)
  return user && user?.isLDMUser ? (
    <Route path={path} component={component} />
  ) : (
    <Redirect to={"/login"} />
  );
};

export default ProtectedRoute;
